import React, {Fragment} from 'react';

import {Filter} from 'presentation/components/Filter';
import {Drawer} from 'presentation/components/Drawer';
import {translations} from 'presentation/translations-new';
import {useTypeFilter} from './Hooks/useTypeFilter';
import {TypeFilterProps} from './types';

const {clearFilterButton} = translations['pt-br'].privateFlow.myReferrals;
const {applyFilters, filter, filters} = translations['pt-br'].commons;

export function TypeFilter(props: TypeFilterProps) {
	const {
		openDrawerState,
		setOpenDrawerState,
		listFilters,
		handleClearFilters,
		handleSubmitFilters,
	} = useTypeFilter(props);
	return (
		<Fragment>
			<Filter.Button onClick={() => setOpenDrawerState(true)} count={props.showCount ? 1 : 0} data-tag-id={props.dataTagId?.openBtn}>
				{filter}
			</Filter.Button>
			<Drawer.Root
				open={openDrawerState}
				onClose={() => setOpenDrawerState(false)}
				onOpen={() => null}>
				<Drawer.Header title={filters} onClose={() => setOpenDrawerState(false)} closeBtnDataTagId={props.dataTagId?.closeBtn} />
				<Drawer.ContentListByCategory categoryList={listFilters} />
				<Drawer.Footer
					firstButtonDataTagId={props.dataTagId?.clearBtn}
					firstButtonTitle={clearFilterButton}
					firstButtonOnClick={() => handleClearFilters()}
					secondButtonDataTagId={props.dataTagId?.applyBtn}
					secondButtonTitle={applyFilters}
					secondButtonOnClick={() => handleSubmitFilters()}
				/>
			</Drawer.Root>
		</Fragment>
	);
}
